/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { ApplicationState } from 'store';
import { legislation } from 'store/modules/juridico_facil_store/actions';
import { JuridicoFacilState } from 'store/modules/juridico_facil_store/types';
import Loader from 'components/atoms/loader';

const ListLei = () => {
  const dispatch = useDispatch();
  const { juridico, request } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  useEffect(() => {
    dispatch(legislation());
  }, []);
  return (
    <div className="row mt-4">
      {request?.legislation?.loading ? (
        <Loader />
      ) : (
        juridico?.leis.map((lei) => (
          <div className="col-sm-4 mb-2">
            <div className="card tour-legislation-result">
              <div className="card-body">
                <h5 className="card-title">
                  {lei?.tipo === 'Constituição da República Federativa do Brasil'
                    ? 'Constituição'
                    : `${lei?.tipo} nº ${lei?.numero}`}
                </h5>
                <div className="card-text">
                  <span className="text-secondary">#{lei?.ementa?.slice(0, 80)}</span>
                </div>
                <div className="d-flex align-items-end flex-column">
                  <a
                    href={`legislacao/lei/${lei?.id}`}
                    className="badge badge-primary tour-legislation-btn"
                  >
                    Abrir
                  </a>
                </div>
              </div>
              <div className="card-footer">
                <span className="text-muted" style={{ fontSize: '12px' }}>
                  {`${lei?.tipo} ${
                    lei?.numero === 'Constituição' || '123' ? '' : lei?.esfera
                  } de ${moment(lei?.data).format('LL')}`}
                </span>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ListLei;
